import type { Role } from "@/Common/Models/Domain/Role";
import type { Day } from "@/Common/Models/Domain/Day";
import type { iconName } from "@/Modules/App/Models/Styles/Icons";
import type { ACNotificationTypeApi } from "@/Modules/Models/Api/ActivityCenter";

export enum NotificationStatus {
  NEW = "news",
  ACTION_REQUIRED = "action_required",
  READ = "readed",
}

export interface ACNotification {
  uuid: string;
  createdAt: number;
  updatedAt: number | null;
  eventType: ACNotificationTypeApi;
  metadata: NotificationMetadata;
  isRead: boolean;
  isActionRequired: boolean;
  isActionRequiredCompleted: boolean;
  patientUuid: string;
  therapistUuid: string;
  title: string;
  message: string;
  link?: string;
  icon: iconName;
  role: Role;
  noAction?: boolean; // the click not generate action
  isHide?: boolean; // hide in the front.
}

interface NotificationMetadata {
  username?: string;
  formName?: string;
  date?: number;
  planUuid?: string;
  userQuestionnaireUuid?: string;
  chatUuid: string;
  planTitle: string;
  therapistName: string;
}

export interface NotificationSection {
  page?: number | undefined;
  title: Day | string;
  notifications: ACNotification[];
  unreadedNotifications?: number;
  finished?: boolean;
}

export interface NotificationTypeSummary {
  [key: string]: NotificationSection;
}

export interface NotificationPagination {
  [key: string]: number | null;
}
